export default __webpack_public_path__ + "static/media/check.19198ce1.svg";